<template>
    <v-card>
        <v-card-title primary-title>
            <h3 class="headline mb-0">Latest Transactions {{ deviceTID }}</h3>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :pagination.sync="pagination"
                :headers="transactionHeaders"
                :items="transactions"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td>{{ parseDate(props.item.completed_at).format('YY-MM-DD HH:mm') }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ upperCaseFirst(props.item.txnType) }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ upperCaseFirst(props.item.source) }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ props.item.amount }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ props.item.card_type }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ upperCaseFirst(props.item.response) }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ upperCaseFirst(props.item.result) }}</td>
                <td class="subheading" @click="transactionLink(props.item.uuid)">{{ props.item.response_text }}</td>
                <td>{{ props.item.message }}</td>
                <td>{{ props.item.balance }}</td>
                <td>{{ props.item.batch }}</td>
                <td>{{ props.item.uuid }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
    </v-card>
</template>

<script>
    import Moment from 'moment'
    import {mapActions} from 'vuex'

    const fb = require('../firebase')
    export default {
        name: 'DeviceTransactionList',
        props: ['id', 'group'],
        data() {
            return {
                search: '',
                panel: [true],
                transactions: [],
                pagination: {'sortBy': 'Date', 'descending': true, 'rowsPerPage': 5},
                rowsPerPage: [10, 25, 50, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                transactionHeaders: [
                    {text: 'Date', align: 'left', sortable: true, value: 'completed_at'},
                    {text: 'Type', align: 'left', sortable: true, value: 'txnType'},
                    {text: 'Source', align: 'left', sortable: true, value: 'source'},
                    {text: 'Amount', align: 'left', sortable: true, value: 'amount'},
                    {text: 'Card Type', align: 'left', sortable: true, value: 'card_type'},
                    {text: 'Response', align: 'left', sortable: true, value: 'response'},
                    {text: 'Result', align: 'left', sortable: true, value: 'result'},
                    {text: 'Text', align: 'left', sortable: true, value: 'response_text'},
                    {text: 'Msg', align: 'left', sortable: true, value: 'message'},
                    {text: 'Balance', align: 'left', sortable: true, value: 'balance'},
                    {text: 'Batch', align: 'left', sortable: true, value: 'batch'},
                    {text: 'UUID', align: 'left', sortable: true, value: 'uuid'}
                ]
            }
        },
        mounted() {
            if (!this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
            }
            this.fetchTransactions()
        },
        computed: {
            deviceTID: function () {
                let device = this.$store.state.devices['castles_' + this.id + '@kineticsmart.com']
                if (device === undefined) {
                    return ''
                }
                return ' for TID: ' + device['merchant.terminalid']
            }
        },
        methods: {
            ...mapActions(['isUserLoggedIn']),
            transactionLink: function (val) {
                this.$router.push('/transaction/' + this.$props.group + '/' + this.$props.id + '/' + val)
            },
            parseDate: function (val) {
                val = Number(val)
                if (val === 0) {
                    return 'Invalid date'
                }
                return Moment.unix(val) // .format('YYYY-MM-DD-HH:MM')
            },
            upperCaseFirst: function (val) {
                if (val === undefined) {
                    return ''
                }
                return val.charAt(0).toUpperCase() + val.substr(1)
            },
            fetchTransactions: function () {
                this.$store.commit('showProgress')

                let device = this.$store.state.devices['castles_' + this.id + '@kineticsmart.com']

                if (device !== undefined) {

                    // console.log(device)

                    fb.transactionsCollection
                    //.where('deviceId', '==', device.id )
                        .where('terminal_id', '==', device['merchant.terminalid'])
                        .orderBy('timestamp', 'desc')
                        .limit(500)
                        .get()
                        .then((transactions) => {
                            this.$store.commit('hideProgress')
                            transactions.forEach((transaction) => {
                                let t = transaction.data()
                                this.transactions.push({
                                    id: transaction.id,
                                    completed_at: t['created_at'],
                                    txnType: t['transaction_type'],
                                    source: t['data_source'],
                                    amount: ((Number(t['base_amount']) + Number(t['tip_amount']) + Number(t['cashback_amount'])) / 100).toFixed(2),
                                    card_type: t['card_network'].toUpperCase(),
                                    response: t['acquirer_response'],
                                    result: t['result'],
                                    response_text: t['result_text'],
                                    message: t['message_number'],
                                    balance: t['balance_code'],
                                    batch: (Number(t['batch_total']) / 100).toFixed(2),
                                    uuid: t['uuid']
                                })
                            })
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>
